import { CompensationStatus, CompensationType, EmployeeStatus, Namespace } from 'enums';

export default {
  [Namespace.Common]: {
    cancel: 'Отменить',
    save: 'Сохранить',
    saveChanges: 'Сохранить изменения',
    edit: 'Редактировать',
    requestFailed: 'Запрос не выполнен',
    somethingWentWrong: 'Что-то пошло не так. Попробуйте позже либо нажмите Сообщить о проблеме.',
    success: 'Операция выполнена успешно',
    employeesRequests: 'Заявки сотрудников',
    createRequest: 'Создать заявку',
    username: 'Имя сотрудника',
    createdOn: 'Создано',
    targetPeriod: 'Расчётный период',
    compensationType: 'Тип выплаты',
    status: 'Статус',
    byEmployee: 'По сотруднику',
    byEmployeeStatus: 'По статусу сотрудника',
    byPeriod: 'По расчётному периоду',
    byType: 'По типу выплаты',
    byEntity: 'По юридическому лицу',
    byStatus: 'По статусу',
    clear: 'Очистить',
    autocompletePlaceholder: 'Имя или логин сотрудника',
    exportRequests: 'Экспортировать в Excel',
    exportTooltip: 'Экспорт будет выполнен с учётом примененных к таблице фильтров и сортировок',
    requestDetails: 'Детали заявки',
    employee: 'Сотрудник',
    legalEntity: 'Юридическое лицо',
    employeeStatus: 'Статус сотрудника',
    department: 'Департамент',
    period: 'Расчётный период',
    applicationCreatedOn: 'Дата создания заявки',
    employeeComment: 'Комментарий сотрудника',
    reviewerComment: 'Комментарий администратора',
    billedOn: 'Дата выдачи чека',
    originalPaymentSum: 'Сумма заявки',
    requestCurrency: 'Валюта заявки',
    requestToRuleCurrencyRate: 'Курс конверсии заявка/правило',
    ruleToEmployeeCurrencyRate: 'Курс конверсии правило/аккаунт',
    requestToEmployeeCurrencyRate: 'Курс конверсии заявка/аккаунт',
    totalSum: 'Итого к начислению',
    employeeCurrency: 'Валюта баланса сотрудника',
    error: 'Ошибка',
    select: 'Выбрать',
    all: 'Все',
    selectAll: 'Выбрать все',
    updateApplications: 'Обновить заявки',
    deleteRequestConfirm: 'Вы уверены, что хотите удалить заявку?',
    delete: 'Удалить',
    deletedRequestNotification: 'Заявка удалена.',
  },
  [Namespace.Navigation]: {
    navigation: 'Основная навигация',
    personal: 'Личное',
    management: 'Управление',
    helpSupport: 'Помощь и поддержка',
    collapseSidebar: 'Свернуть меню',
    expandSidebar: 'Развернуть меню',
    personalArea: 'Личный кабинет',
    employeeRequests: 'Заявки сотрудников',
    archive: 'Архив',
    reports: 'Отчёт',
    settings: 'Настройки',
    news: 'Новости',
    reportAnIssue: 'Сообщить о проблеме',
    exit: 'Выход',
    logOut: 'Выйти',
  },
  [Namespace.PersonalArea]: {
    myRequests: 'Мои заявки',
    createRequest: 'Создать заявку',
    createdOn: 'Создано',
    targetPeriod: 'Расчётный период',
    compensationType: 'Тип выплаты',
    status: 'Статус',
    requestDetails: 'Детали заявки',
    moreInformation: 'С подробной информацией о социальном пакете можно ознакомиться',
    guideInformation: 'С руководством пользователя можно ознакомиться',
    here: 'здесь',
    accessDenied: 'Система работает только для сотрудников из офисов в Беларуси, Литве, Польше, Грузии и Узбекистане.',
    otherRequests: 'Архив',
  },
  [Namespace.CompensationForm]: {
    compensationType: 'Тип выплаты',
    consentRequiredError: 'Необходимо подтвердить согласие',
    consentLabel:
      'Согласен(на) на обработку моих специальных персональных данных в целях компенсации медицинских расходов.',
    consentNoteLabel: 'Развернутое пояснение:',
    consentNotePurpose:
      'Цель обработки персональных данных: организация и начисление компенсации медицинских расходов.',
    consentNoteData:
      'В рамках данного согласия могут обрабатываться следующие персональные данные: ФИО, наименование оказанных медицинских услуг, иная информация, содержащаяся в актах сдачи-приёмки оказанных медицинских услуг.',
    consentNoteLaw:
      'Данные обрабатываются в соответствии с законодательством и хранятся в течение 2 лет с даты их получения, после чего удаляются.',
    consentLabelRobotics:
      'Согласен(на) на обработку персональных данных моего ребенка в целях компенсации расходов на robotics courses.',
    consentNotePurposeRobotics:
      'Цель обработки персональных данных: организация и начисление компенсации расходов на robotics courses.',
    consentNoteDataRobotics:
      'В рамках данного согласия могут обрабатываться следующие персональные данные: ФИО ребенка, дата рождения ребенка, иная информация, содержащаяся в предоставляемых документах.',
    consentNoteLawRobotics:
      'Данные обрабатываются в соответствии с законодательством и хранятся до конца расчетного года, после чего удаляются.',
    expiredAttachments: 'Вложение удалено в соответствии с политикой хранения (2 года)',
    employeeError: 'Укажите имя или логин сотрудника',
    compensationTypeError: 'Выберите тип выплаты',
    billAmount: 'Сумма чека',
    billAmountPlaceholder: 'Не указана',
    billAmountError: 'Укажите сумму чека',
    paymentAmount: 'Сумма выплаты',
    paymentAmountPlaceholder: 'Не указана',
    paymentAmountError: 'Укажите сумму выплаты',
    currency: 'Валюта',
    currencyError: 'Укажите валюту',
    billedOn: 'Дата выдачи чека',
    billedOnError: 'Укажите дату выдачи чека',
    targetPeriod: 'Расчетный период',
    targetPeriodError: 'Укажите расчетный период',
    employeeComment: 'Комментарий сотрудника',
    employeeCommentPlaceholder: 'Не указан',
    reviewerComment: 'Комментарий администратора',
    reviewerCommentPlaceholder: 'Не указан',
    attachments: 'Прикрепленные файлы',
    attachFile: 'Прикрепить файл',
    attachmentCountHelper: 'Максимум {{count}} вложений',
    attachmentFileSizeHelper: 'Каждый файл не должен превышать {{size}} МБ',
    attachmentSingleFileSizeError: 'Размер файла не может превышать {{size}} МБ',
    attachmentFileExtensionHelper: 'Допустимые форматы: {{extensions}}',
    attachmentStorageInfo: 'Вложения хранятся в течение 2 лет',
    submitCompensation: 'Отправить на рассмотрение',
    attachmentSizeError: 'Общий размер вложений превышает {{size}} МБ',
    attachmentCountError: 'Количество вложений не может превышать {{count}}',
    attachmentDuplicateError: 'Файл с таким названием и размером уже прикреплен',
    employee: 'Сотрудник',
    employeePlaceholder: 'Имя или логин сотрудника',
    attachmentsError: 'Прикрепите подтверждающий документ',
    status: 'Статус',
  },
  [Namespace.CompensationStatuses]: {
    [CompensationStatus.Pending]: 'На рассмотрении',
    [CompensationStatus.Approved]: 'Утверждена',
    [CompensationStatus.Rejected]: 'Отклонена',
    [CompensationStatus.UpdateRequired]: 'Ожидает корректировки',
    [CompensationStatus.Closed]: 'Закрыта',
    [CompensationStatus.Failed]: 'Ошибка экспорта',
  },
  [Namespace.EmployeeStatuses]: {
    [EmployeeStatus.Employee]: 'Сотрудник',
    [EmployeeStatus.Evaluation]: 'Испытательный срок',
    [EmployeeStatus.Registered]: 'Зарегистрирован',
    [EmployeeStatus.Freelancer]: 'Фрилансер',
    [EmployeeStatus.Dismissed]: 'Уволен',
  },
  [Namespace.CompensationTypes]: {
    [CompensationType.None]: 'Невалидный тип выплаты',
    [CompensationType.Sport]: 'Компенсация спортивных абонементов',
    [CompensationType.Medical]: 'Компенсация медицинских расходов',
    [CompensationType.Robotics]: 'Курсы робототехники',
    [CompensationType.Wedding]: 'Материальная помощь: свадьба',
    [CompensationType.Children]: 'Материальная помощь: рождение ребенка',
    [CompensationType.FamilyFuneral]: 'Материальная помощь: смерть члена семьи',
    [CompensationType.Recommendation]: 'Рекомендация на вакансию',
    [CompensationType.InternetCompensation]: 'Компенсация интернета',
    [CompensationType.Other]: 'Иные выплаты',
  },
  [Namespace.CompensationTypesHelpers]: {
    [CompensationType.Sport]:
      '<paragraph>Приложите документы, подтверждающие оплату: чек/договор/абонемент.</paragraph>' +
      '<paragraph>Абонементы (в том числе разовые) принимаются для компенсации в первые 30 дней после их приобретения.</paragraph>' +
      '<paragraph>Если абонемент действует несколько месяцев, в поле "Расчетный период" укажите тот месяц, когда он был приобретён.</paragraph>' +
      '<paragraph>Документы за разовые занятия предоставляйте в одной общей заявке в конце месяца.</paragraph>',
    [CompensationType.Robotics]:
      '<paragraph>Приложите седующие документы:</paragraph>' +
      '<list><listItem>чек или иной документ, подтверждающий оплату</listItem>' +
      '<listItem>договор с организацией, которая проводит курсы, с указанием: ФИО ребенка, периода проведения занятий, количества часов, суммы к оплате</listItem></list>',
    [CompensationType.Wedding]: '<paragraph>Приложите свидетельство о заключении брака.</paragraph>',
    [CompensationType.Children]: '<paragraph>Приложите свидетельство о рождении ребёнка.</paragraph>',
    [CompensationType.FamilyFuneral]:
      '<paragraph>Приложите подтверждающие документы:</paragraph>' +
      '<list><listItem>документы, подтверждающие родство, в том числе если была смена фамилии (например: свидетельство о рождении, свидетельство о заключении брака родителей, свидетельство о собственном браке)</listItem>' +
      '<listItem>свидетельство о смерти родственника</listItem></list>',
  },
  [Namespace.Settings]: {
    settings: 'Настройки',
    permissions: 'Права доступа',
    conditionsForSettlements: 'Условия для расчетов',
    taxRates: 'Ставки налогов',
    userLogin: 'Логин сотрудника',
    username: 'Имя сотрудника',
    userOrGroupPlaceholder: 'Имя пользователя или логин, AD группа',
    adGroup: 'Группа Active Directory',
    editAccess: 'Редактировать доступ',
    hasAdministratorPermission: 'Администрирование',
    hasRequestCompensationPermission: 'Создание заявок от имени любого сотрудника',
    hasManageCompensationsPermission: 'Управление заявками',
    compensationType: 'Тип выплаты',
    requiresBill: 'Необходим чек',
    fixedAmount: 'Сумма выплаты зафиксирована',
    amount: 'Сумма $ (если зафиксирована)',
    amountPercent: 'Процент от суммы чека',
    amountLimit: 'Max сумма выплаты',
    currency: 'Валюта',
    taxRateIndividual: 'Ставка налога ФЛ',
  },
  [Namespace.NotFound]: {
    notFoundTitle: 'Страница не найдена',
    notFoundMessage: 'Возможно вы указали некорректный адрес или страница устарела и была удалена',
  },
  [Namespace.AccessDenied]: {
    accessDenied: 'Доступ запрещен',
  },
  [Namespace.Reports]: {
    reportGeneration: 'Формирование отчёта',
    managingBillingPeriods: 'Управление расчетными периодами',
    managingStatuses: 'Управление статусами заявок',
    exportInMatrix: 'Экспортировать в Matrix',
    compensationType: 'Тип выплаты',
    closePeriod: 'Закрыть расчетный период',
    allPeriodsClosed: 'Все прошедшие расчётные периоды закрыты',
    closePeriodModalTitle: 'Закрытие расчетного периода',
    exportModalTitle: 'Экспорт в Matrix',
    billingPeriod: 'Расчётный период',
    confirmClosePeriodText: 'Вы уверены, что хотите закрыть данный расчётный период?',
    confirmExportText: 'Вы уверены, что хотите экспортировать отчёт в Matrix?',
    employee: 'Сотрудник',
    statusRequest: 'Статус заявки',
    statusEmployee: 'Статус сотрудника',
    legalEntity: 'Юридическое лицо',
    compensationTypesError: 'Выберите тип выплаты',
    employeesError: 'Выберите сотрудника',
    periodsError: 'Выберите расчётный период',
    statusesError: 'Выберите статус заявки',
    entityError: 'Выберите юридическое лицо',
    changeStatuses: 'Изменить статусы заявок',
    numberOfApplications: 'Количество заявок:',
    apply: 'Применить',
    all: 'Все',
  },
  [Namespace.StatusActions]: {
    [Namespace.Short]: {
      [CompensationStatus.Approved]: 'Утвердить',
      [CompensationStatus.Rejected]: 'Отклонить',
      [CompensationStatus.UpdateRequired]: 'Отправить на корректировку',
    },
    [Namespace.Long]: {
      [CompensationStatus.Approved]: 'Утвердить заявку',
      [CompensationStatus.Rejected]: 'Отклонить заявку',
      [CompensationStatus.UpdateRequired]: 'Отправить заявку на корректировку',
    },
  },
  [Namespace.News]: {
    news: 'Новости',
    noPosts: 'Пока нет новых постов.',
    actualNews: 'Актуальные новости:',
    previousNews: 'Предыдущие новости:',
    viewDetailsLink: 'Подробнее',
  },
};
